import { render, staticRenderFns } from "./JuHui2.vue?vue&type=template&id=1b0d3466&"
import script from "./JuHui2.vue?vue&type=script&lang=js&"
export * from "./JuHui2.vue?vue&type=script&lang=js&"
import style0 from "./JuHui2.vue?vue&type=style&index=0&id=1b0d3466&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports